import React from 'react';
import { Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { ButtonV2 } from 'components/common/ui';
import B2BAddOrderBookingField from './B2BAOrderBookingField';

import styles from './b2BOrderBookings.style';

export const B2BOrderBookingFields = ({
  methods,
  isLoading,
  fields,
  vehicles,
  onAdd,
  onRemove,
}) => {
  return (
    <Box>
      {fields.length > 0 && (
        <>
          {fields.map((field, index) => (
            <B2BAddOrderBookingField
              key={field.id}
              index={index}
              field={field}
              methods={methods}
              isLoading={isLoading}
              vehicles={vehicles}
              onRemove={onRemove}
            />
          ))}
        </>
      )}
      <Box sx={styles.footer}>
        <ButtonV2 onClick={onAdd} variant="secondary">
          <AddIcon data-testid="AddIcon" sx={styles.icon} />
        </ButtonV2>
      </Box>
    </Box>
  );
};

export default B2BOrderBookingFields;
